import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { USER_SIGNED_OUT } from "redux-oidc";
import {getInitialUserAndAppInfos, setUserSelected, setUserSelectedReturn, verifyAdminAccess} from "./auth.action";
import type { AuthState, User } from "./auth.types";

/**
 * Etape du cycle de vie d'une authentification.
 */
export enum AuthStep {
	/**
	 * Démarrage d'une authentification.
	 */
	Starting = "starting",
	/**
	 * Récupération d'infos utilisateur.
	 */
	RetrieveUserInfos = "retrieve_infos",
	/**
	 * Etat connecté, l'IHM est utilisable.
	 */
	Connected = "connected",
	/**
	 * Etat final déconnecté, aucune action possible.
	 */
	Disconnected = "disconnected",
}

/**
 * Etat de l'authentification dans l'application.
 */
const initialState: AuthState = {
	step: AuthStep.Starting,
	delegants: [],
	isAdminMode: null
};

const slice = createSlice({
	name: "auth",
	initialState: initialState,
	reducers: {},
	extraReducers: {
		[getInitialUserAndAppInfos.pending.toString()]: (state) => {
			state.step = AuthStep.RetrieveUserInfos;
		},
		[getInitialUserAndAppInfos.fulfilled.toString()]: (state, action: PayloadAction<User[]>) => {
			state.user = action.payload[0];
			state.delegants = action.payload;
			state.step = AuthStep.Connected;
		},
		//Abonnement à l'action de déconnexion de redux-oidc
		[USER_SIGNED_OUT]: (state) => {
			console.log("User signed out event " + new Date());
			state.step = AuthStep.Disconnected;
		},

		[setUserSelected.fulfilled.toString()]: (state, { payload }: PayloadAction<setUserSelectedReturn>) => {
			state.user = payload.selected;
		},

		[verifyAdminAccess.fulfilled.toString()]: (state, action: PayloadAction<boolean>) => {
			state.isAdminMode = action.payload;
		},
	},
});

export const { reducer: authReducer } = slice;

export const selectSessionUser = (state: AuthState) => state.user;
export const selectAuthError = (state: AuthState) => state.authError;
export const selectAuthStep = (state: AuthState) => state.step;
